<template>
  <CookieMessage />
  <EventBanner />

  <div class="main-header">
    <Header />
  </div>

  <main class="main">
    <router-view />
  </main>

  <GoToTopButton />

  <div class="main-footer">
    <Footer />
  </div>
</template>

<script>
import CookieMessage from '@/components/Cookies/CookieMessage.vue'
import EventBanner from '@/components/EventBanner/EventBanner.vue'
import Header from '@/components/AppHeader.vue'
import Footer from '@/components/Footer.vue'
import GoToTopButton from '@/components/Global/GoToTopButton.vue'

export default {
  name: 'HomeView',
  components: {
    CookieMessage,
    EventBanner,
    Header,
    Footer,
    GoToTopButton,
  },
}
</script>
